import { Injectable } from '@angular/core';
import { HttpClient } from './http-client.service';
import { Customer, Address, PageableSearch } from '../../models';
import { Logger } from '../logger.service';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';

export interface Query {
	firstname: string
	lastname: string
	postalCode: string
	city: string
	street: string
	company: string
	email: string
	page: number
}

@Injectable()
export class CustomerApi {
	private customerApi = '/api/customer-management/v1/customers';

	constructor(private httpClient: HttpClient, private logger: Logger) {}

	public loadCustomerById(uuid: string): Observable<Customer> {
		this.logger.info("Get Customer by uuid:" + uuid);
		return this.httpClient.get(this.customerApi + "/" + uuid)
			.map(response => <Customer>response.json())
			.catch(this.handleError);
	}

	public createCustomer(customer: Customer): Observable<Customer> {
		let body: string = JSON.stringify(customer)
		return this.httpClient.post(this.customerApi, body)
			.map(response => <Customer>response.json())
			.catch(this.handleError)
	}

	public updateCustomer(url: string, customer: Customer): Observable<Customer> {
		let body: string = JSON.stringify(customer)
		return this.httpClient.patch(url, body)
			.map(response => <Customer>response.json())
			.catch(this.handleError)
	}

	public search(query: Query): Observable<PageableSearch<Customer>> {
		const url = this.buildSearchUrl(query);
		return this.httpClient.get(url).map(response => response.json());
	}

	public updateAddress(customerUUID: string, address: Address) {
		let body = JSON.stringify(address);
		return this.httpClient.put(this.customerApi + "/" + customerUUID + "/addresses/" + address.uuid, body)
			.map(response => <Customer>response.json())
			.catch(this.handleError);
	}

	public createAddress(customerUUID: string, address: Address) {
		let body = JSON.stringify(address);
		return this.httpClient.post(this.customerApi + "/" + customerUUID + "/addresses", body)
			.map(response => <Customer>response.json())
			.catch(this.handleError);
	}

	public makeDefaultBillingAddress(customerUUID: string, address: Address) {
		let body = JSON.stringify(address);
		return this.httpClient.put(this.customerApi + "/" + customerUUID + "/addresses/defaultBillingAddress" , body)
			.map(response => <Customer>response.json())
			.catch(this.handleError);
	}

	public makeDefaultShippingAddress(customerUUID: string, address: Address) {
		let body = JSON.stringify(address);
		return this.httpClient.put(this.customerApi + "/" + customerUUID + "/addresses/defaultShippingAddress" , body)
			.map(response => <Customer>response.json())
			.catch(this.handleError);
	}

	public relocateCustomer(url: string, address: Address): Observable<Customer> {
		let body: string = JSON.stringify(address)
		return this.httpClient.post(url, body)
			.map(response => <Customer>response.json())
			.catch(this.handleError)
	}

	public deleteCustomer(url: string): Observable<Response> {
		return this.httpClient.delete(url)
					.catch(this.handleError)
	}

	private buildSearchUrl(query: Query) {
		let url =  this.customerApi + "?f=f"
		if (query.firstname)
			url += "&firstname=" + query.firstname
		if (query.lastname)
			url += "&lastname=" + query.lastname
		if (query.company)
			url += "&companyName=" + query.company
		if (query.postalCode)
			url += "&postalCode=" + query.postalCode
		if (query.city)
			url += "&city=" + query.city
		if (query.street)
			url += "&street=" + query.street
		if(query.email)
			url += "&email=" + query.email
		url += "&page=" + query.page
		return url;
	}

	private handleError = (error: Response) => {
		this.logger.error(error);
		return Observable.throw(error);
	}
}



// WEBPACK FOOTER //
// ./src/app/services/webservice/customer-api.service.ts